import React from 'react';

import AemComponent from '@/components/Aem/AemComponent/AemComponent';
import EditableText from '@/components/Aem/EditableText/EditableText';
import {AppButton} from '@/components/Button';
import * as advanceDiagnosticScreenTypes from '@/consts/advanceDiagnostic/advanceDiagnosticScreenTypes';
import {
    ADVANCED_DIAGNOSTICS_CLEANING_CONTACTS_GOT_IT_BUTTON_ARIA_LABEL,
    ADVANCED_DIAGNOSTICS_CLEANING_CONTACTS_NOT_NOW_BUTTON_ARIA_LABEL,
    ADVANCED_DIAGNOSTICS_CLEANING_CONTACTS_TRY_AGAIN_BUTTON_ARIA_LABEL,
} from '@/consts/localization/localizationKeys';
import routePaths from '@/consts/route/routePaths';
import {getAriaLabel} from '@/services/accessibilityService';
import appRouterService from '@/services/route/appRouterService';

import NotNowButtonAD from '../components/NotNowButtonAD';
import useRedirectToPhase2 from '../hooks/useRedirectToPhase2';

const AdvancedDiagnosticCleaningContactsButtons = ({isLastSlide}) => {
    // TODO: VR add phase2
    const isOkGotIt = isLastSlide;

    const okGotItClick = () => {
        appRouterService.forwardToDevicesPage();
    };
    const redirectToPhase2 = useRedirectToPhase2();
    const onTryAgainClick = () => redirectToPhase2();

    return (
        <>
            {isOkGotIt && (
                <AppButton
                    primary
                    light
                    onClick={okGotItClick}
                    className='my-0 w-full'
                    aria-label={getAriaLabel(ADVANCED_DIAGNOSTICS_CLEANING_CONTACTS_GOT_IT_BUTTON_ARIA_LABEL)}
                >
                    <AemComponent
                        component={EditableText}
                        pageName={routePaths.ADVANCE_DIAGNOSTIC}
                        itemName='cleaningcontactsgotitbutton'
                    />
                </AppButton>
            )}
            {!isOkGotIt && isLastSlide && (
                <AppButton
                    primary
                    light
                    onClick={onTryAgainClick}
                    className='my-0 w-full'
                    aria-label={getAriaLabel(ADVANCED_DIAGNOSTICS_CLEANING_CONTACTS_TRY_AGAIN_BUTTON_ARIA_LABEL)}
                >
                    <AemComponent
                        component={EditableText}
                        pageName={routePaths.ADVANCE_DIAGNOSTIC}
                        itemName='cleaningcontactstryagainbutton'
                    />
                </AppButton>
            )}
            {!isOkGotIt && !isLastSlide && (
                <NotNowButtonAD
                    secondary
                    isHolder
                    className='my-0 w-full'
                    screenName={advanceDiagnosticScreenTypes.CLEANING_CONTACTS_SCREEN}
                    aria-label={getAriaLabel(ADVANCED_DIAGNOSTICS_CLEANING_CONTACTS_NOT_NOW_BUTTON_ARIA_LABEL)}
                >
                    <AemComponent
                        component={EditableText}
                        pageName={routePaths.ADVANCE_DIAGNOSTIC}
                        itemName='cleaningcontactsnotnowbutton'
                    />
                </NotNowButtonAD>
            )}
        </>
    );
};

export default AdvancedDiagnosticCleaningContactsButtons;
